<template>
  <div>
    <div class="d-flex" v-if="!hideLabel">
      <div>Grau de Risco</div>

      <t-help click :modal-title="'Legenda - Matriz GUT'">

        <div class="gut-legenda">
          <div class="gut-titulo"><strong>Matriz GUT (G x U x T)</strong></div>

          <div class="gut-texto">
            A Matriz GUT &eacute; utilizada para definir a prioridade de interven&ccedil;&atilde;o das anomalias identificadas, considerando:
          </div>

          <ul class="gut-lista-def">
            <li><strong>G &ndash; Gravidade:</strong> impacto do problema (seguran&ccedil;a, desempenho, danos).</li>
            <li><strong>U &ndash; Urg&ecirc;ncia:</strong> prazo necess&aacute;rio para a&ccedil;&atilde;o corretiva.</li>
            <li><strong>T &ndash; Tend&ecirc;ncia:</strong> evolu&ccedil;&atilde;o do problema ao longo do tempo.</li>
          </ul>

          <div class="gut-texto">
            A pontua&ccedil;&atilde;o final &eacute; obtida por <strong>G x U x T</strong>.
          </div>

          <div class="gut-subtitulo"><strong>Classifica&ccedil;&atilde;o por Prioridade</strong></div>

          <ul class="gut-lista-prioridade">
            <li class="gut-item gut-verde">
              <span class="gut-bolinha" style="background-color:#E4FDE1;border-color:#7AF400;"></span>
              <strong>Baixa Prioridade (1 a 15)</strong><br>
              Situa&ccedil;&atilde;o controlada. Recomenda-se apenas monitoramento.
            </li>

            <li class="gut-item gut-amarelo">
              <span class="gut-bolinha" style="background-color:#FFF6D6;border-color:#F5C542;"></span>
              <strong>Prioridade M&eacute;dia (16 a 35)</strong><br>
              Aten&ccedil;&atilde;o t&eacute;cnica. Corre&ccedil;&atilde;o program&aacute;vel.
            </li>

            <li class="gut-item gut-laranja">
              <span class="gut-bolinha" style="background-color:#FDEFE1;border-color:#FDA86A;"></span>
              <strong>Alta Prioridade (36 a 74)</strong><br>
              Risco relevante. Interven&ccedil;&atilde;o recomendada em curto prazo.
            </li>

            <li class="gut-item gut-vermelho">
              <span class="gut-bolinha" style="background-color:#FDE1E1;border-color:#FF6A6A;"></span>
              <strong>Prioridade M&aacute;xima (75 a 125)</strong><br>
              Risco cr&iacute;tico. Interven&ccedil;&atilde;o imediata para evitar danos ou acidentes.
            </li>
          </ul>
        </div>

      </t-help>
    </div>
    <t-input
        label="Grau de Risco"
        :class-input="riskClass"
        hide-label
        :value="riskResult"

        fixed
        highlight
        readonly
    ></t-input>


  </div>
</template>
<style>
.occurrence-risk-danger {
  background-color: #FDE1E1 !important;
  border-color: #FF6A6A !important;
}

.occurrence-risk-warning {
  background-color: #FDEFE1 !important;
  border-color: #FDA86A !important;
}

.occurrence-risk-attention {
  background-color: #FFF6D6 !important;
  border-color: #F5C542 !important;
}

.occurrence-risk-success {
  background-color: #E4FDE1 !important;
  border-color: #7AF400 !important;
}

.occurrence-risk-light {
  background-color: #F8F9FA !important;
  border-color: #CED4DA !important;
}
.gut-legenda{font-size:13px;line-height:1.35;}
.gut-titulo{margin-bottom:6px;}
.gut-subtitulo{margin-top:10px;margin-bottom:6px;}
.gut-texto{margin:6px 0;}
.gut-lista-def{margin:6px 0 8px 18px;padding:0;}
.gut-lista-prioridade{list-style:none;margin:6px 0 0 0;padding:0;}
.gut-item{margin:8px 0;padding:8px 10px;border:1px solid #CED4DA;border-radius:6px;background:#F8F9FA;}
.gut-bolinha{display:inline-block;width:12px;height:12px;border:2px solid;border-radius:50%;vertical-align:middle;margin-right:8px;}
</style>
<script>
export default {
  name: 't-occurrence-risk',
  data() {
    return {}
  },
  props: {
    typeSeverity: {
      type: Number,
      default: 0
    },
    typeUrgency: {
      type: Number,
      default: 0
    },
    typeTrend: {
      type: Number,
      default: 0
    },
    hideLabel: Boolean,
  },
  mounted() {

  },
  computed: {
    riskResult() {
      const g = Number(this.typeSeverity) || 0
      const u = Number(this.typeUrgency) || 0
      const t = Number(this.typeTrend) || 0
      return g * u * t
    },

    riskClass() {
      const r = this.riskResult

      if (r >= 75) return 'occurrence-risk-danger'     // 🔴 75–125
      if (r >= 36) return 'occurrence-risk-warning'    // 🟠 36–74
      if (r >= 16) return 'occurrence-risk-attention'  // 🟡 16–35
      if (r >= 1) return 'occurrence-risk-success'    // 🟢 1–15
      return 'occurrence-risk-light'                   // ⚪ 0
    }
  }

}
</script>
